import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { useQuery } from '@apollo/client';
import { getAssetUrl } from 'utils/getAssetUrl';
import { ListEmpty } from 'components/shared/List';
import { ImageGallery } from 'components/shared/Image';
import { DialogHeader } from 'components/shared/Dialog/DialogHeader';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Stack } from '@mui/material';

import {
  equipmentImagesApi,
  useEquipmentAssets,
  GetEquipmentAssetsResponse,
  GetEquipmentAssetsVariables,
} from '../../api';

export const PreviewExistingImagesDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.PreviewExistingEquipmentImagesDialog);

  const { handleDelete, isDeleting } = useEquipmentAssets();

  if (!data.equipmentId) throw new Error('Equipment id is required');

  const {
    error,
    data: imagesResponse,
    loading: isImagesLoading,
  } = useQuery<GetEquipmentAssetsResponse, GetEquipmentAssetsVariables>(equipmentImagesApi.fetchAssets, {
    variables: {
      input: {
        entityId: data.equipmentId,
      },
    },
  });

  return (
    <Dialog fullWidth maxWidth="md" open={isOpen} onClose={handleClose}>
      <DialogHeader label="Equipment images" handleClose={handleClose} />

      <DialogContent dividers>
        <RenderWithFallback
          error={error}
          isLoading={isImagesLoading}
          fallBack={
            <Stack height="240px" alignItems="center" justifyContent="center">
              <CircularProgress />
            </Stack>
          }
        >
          <RenderWithCondition fallBack={<ListEmpty />} condition={!!imagesResponse?.equipment.result.assets.length}>
            <ImageGallery
              loading={isDeleting}
              onDelete={handleDelete}
              images={(imagesResponse?.equipment.result.assets ?? []).map(({ source, id }) => ({
                url: getAssetUrl(source),
                id,
              }))}
            />
          </RenderWithCondition>
        </RenderWithFallback>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
